var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlayStore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 232,
    height: 67,
    viewBox: "0 0 232 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M222.944 67H9.05556C4.35214 67 0.5 63.2292 0.5 58.625V8.37501C0.5 3.77085 4.35214 6.67572e-06 9.05556 6.67572e-06H222.944C227.648 6.67572e-06 231.5 3.77085 231.5 8.37501V58.625C231.5 63.2292 227.648 67 222.944 67Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M222.944 1.3421C226.906 1.3421 230.129 4.49738 230.129 8.37501V58.625C230.129 62.5026 226.906 65.6579 222.944 65.6579H9.05556C5.09433 65.6579 1.87103 62.5026 1.87103 58.625V8.37501C1.87103 4.49738 5.09433 1.3421 9.05556 1.3421H222.944ZM222.944 6.67572e-06H9.05556C4.35214 6.67572e-06 0.5 3.77085 0.5 8.37501V58.625C0.5 63.2292 4.35214 67 9.05556 67H222.944C227.648 67 231.5 63.2292 231.5 58.625V8.37501C231.5 3.77085 227.648 6.67572e-06 222.944 6.67572e-06Z",
    fill: "#A6A6A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3555 12.6274C17.8528 13.1425 17.5619 13.9444 17.5619 14.9829V52.0255C17.5619 53.064 17.8528 53.8659 18.3555 54.381L18.4795 54.494L39.6844 33.745V33.255L18.4795 12.506L18.3555 12.6274Z",
    fill: "url(#paint0_linear_63_1707)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7449 40.6648L39.6844 33.745V33.255L46.7534 26.3352L46.9117 26.4252L55.2833 31.088C57.6725 32.4112 57.6725 34.5887 55.2833 35.9204L46.9117 40.5748L46.7449 40.6648Z",
    fill: "url(#paint1_linear_63_1707)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9117 40.5748L39.6844 33.5L18.3554 54.381C19.149 55.1975 20.443 55.2959 21.9146 54.4794L46.9117 40.5748Z",
    fill: "url(#paint2_linear_63_1707)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9117 26.4252L21.9146 12.5206C20.443 11.7124 19.149 11.8108 18.3554 12.6274L39.6844 33.5L46.9117 26.4252Z",
    fill: "url(#paint3_linear_63_1707)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6366 17.1583C81.6366 18.5569 81.2088 19.6771 80.3661 20.5125C79.3972 21.5028 78.1352 22.0011 76.5888 22.0011C75.1109 22.0011 73.8489 21.4944 72.8137 20.4957C71.7763 19.4824 71.2587 18.2387 71.2587 16.75C71.2587 15.2614 71.7763 14.0177 72.8137 13.0127C73.8489 12.0056 75.1109 11.4989 76.5888 11.4989C77.3246 11.4989 78.0262 11.6475 78.6956 11.9239C79.363 12.2024 79.9062 12.5793 80.2998 13.0441L79.4057 13.9276C78.7192 13.1341 77.7845 12.7426 76.5888 12.7426C75.5108 12.7426 74.5761 13.1111 73.7826 13.8544C72.9976 14.5997 72.6041 15.5649 72.6041 16.75C72.6041 17.9351 72.9976 18.9087 73.7826 19.654C74.5761 20.3889 75.5108 20.7658 76.5888 20.7658C77.7331 20.7658 78.6956 20.3889 79.4549 19.6457C79.9554 19.1536 80.2399 18.4753 80.3148 17.6084H76.5888V16.3983H81.5596C81.6195 16.66 81.6366 16.9133 81.6366 17.1583Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5227 12.9624H84.8535V16.1449H89.0628V17.3551H84.8535V20.5376H89.5227V21.7708H83.5316V11.7292H89.5227V12.9624Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M95.088 21.7708H93.7662V12.9624H90.9022V11.7292H97.9541V12.9624H95.088V21.7708Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M103.058 21.7708V11.7292H104.377V21.7708H103.058Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M110.227 21.7708H108.916V12.9624H106.041V11.7292H113.102V12.9624H110.227V21.7708Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M126.453 20.479C125.441 21.4944 124.188 22.0011 122.693 22.0011C121.189 22.0011 119.936 21.4944 118.924 20.479C117.914 19.4656 117.412 18.2219 117.412 16.75C117.412 15.2781 117.914 14.0344 118.924 13.021C119.936 12.0056 121.189 11.4989 122.693 11.4989C124.179 11.4989 125.432 12.0056 126.444 13.0294C127.462 14.0512 127.965 15.2865 127.965 16.75C127.965 18.2219 127.462 19.4656 126.453 20.479ZM119.901 19.6373C120.663 20.3889 121.589 20.7658 122.693 20.7658C123.788 20.7658 124.722 20.3889 125.475 19.6373C126.235 18.8856 126.62 17.9204 126.62 16.75C126.62 15.5796 126.235 14.6144 125.475 13.8627C124.722 13.1111 123.788 12.7342 122.693 12.7342C121.589 12.7342 120.663 13.1111 119.901 13.8627C119.142 14.6144 118.757 15.5796 118.757 16.75C118.757 17.9204 119.142 18.8856 119.901 19.6373Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M129.819 21.7708V11.7292H131.424L136.411 19.5389H136.469L136.411 17.6084V11.7292H137.731V21.7708H136.354L131.13 13.5759H131.073L131.13 15.5147V21.7708H129.819Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M117.087 36.4355C113.068 36.4355 109.784 39.4295 109.784 43.5605C109.784 47.658 113.068 50.6834 117.087 50.6834C121.114 50.6834 124.397 47.658 124.397 43.5605C124.397 39.4295 121.114 36.4355 117.087 36.4355ZM117.087 47.8778C114.881 47.8778 112.984 46.096 112.984 43.5605C112.984 40.9915 114.881 39.2411 117.087 39.2411C119.292 39.2411 121.197 40.9915 121.197 43.5605C121.197 46.096 119.292 47.8778 117.087 47.8778ZM101.154 36.4355C97.1264 36.4355 93.8518 39.4295 93.8518 43.5605C93.8518 47.658 97.1264 50.6834 101.154 50.6834C105.179 50.6834 108.456 47.658 108.456 43.5605C108.456 39.4295 105.179 36.4355 101.154 36.4355ZM101.154 47.8778C98.9466 47.8778 97.043 46.096 97.043 43.5605C97.043 40.9915 98.9466 39.2411 101.154 39.2411C103.359 39.2411 105.256 40.9915 105.256 43.5605C105.256 46.096 103.359 47.8778 101.154 47.8778ZM82.1949 38.6192V41.6468H89.5804C89.3644 43.3386 88.7869 44.5822 87.9014 45.4491C86.8234 46.4959 85.1444 47.658 82.1949 47.658C77.6497 47.658 74.0906 44.0672 74.0906 39.618C74.0906 35.1687 77.6497 31.578 82.1949 31.578C84.6524 31.578 86.4406 32.5181 87.7603 33.7366L89.9398 31.6031C88.0939 29.8778 85.6385 28.5525 82.1949 28.5525C75.9621 28.5525 70.724 33.5168 70.724 39.618C70.724 45.7192 75.9621 50.6834 82.1949 50.6834C85.5636 50.6834 88.0939 49.6031 90.0831 47.5763C92.1214 45.581 92.7567 42.7753 92.7567 40.5099C92.7567 39.8064 92.6968 39.1594 92.5899 38.6192H82.1949ZM159.721 40.9663C159.12 39.373 157.266 36.4355 153.488 36.4355C149.745 36.4355 146.629 39.3227 146.629 43.5605C146.629 47.5512 149.713 50.6834 153.848 50.6834C157.191 50.6834 159.12 48.6881 159.913 47.5261L157.432 45.9076C156.605 47.0927 155.477 47.8778 153.848 47.8778C152.228 47.8778 151.067 47.1513 150.323 45.7192L160.057 41.7766L159.721 40.9663ZM149.797 43.3386C149.713 40.5916 151.976 39.1846 153.597 39.1846C154.868 39.1846 155.946 39.8064 156.305 40.6962L149.797 43.3386ZM141.885 50.25H145.085V29.3125H141.885V50.25ZM136.645 38.0225H136.538C135.819 37.1892 134.448 36.4355 132.711 36.4355C129.066 36.4355 125.734 39.5677 125.734 43.5835C125.734 47.5763 129.066 50.6834 132.711 50.6834C134.448 50.6834 135.819 49.9234 136.538 49.065H136.645V50.0867C136.645 52.8107 135.158 54.2742 132.76 54.2742C130.805 54.2742 129.593 52.8923 129.092 51.7303L126.309 52.8672C127.112 54.7558 129.235 57.0798 132.76 57.0798C136.512 57.0798 139.677 54.9191 139.677 49.6617V36.8689H136.645V38.0225ZM132.985 47.8778C130.78 47.8778 128.934 46.0709 128.934 43.5835C128.934 41.0731 130.78 39.2411 132.985 39.2411C135.158 39.2411 136.871 41.0731 136.871 43.5835C136.871 46.0709 135.158 47.8778 132.985 47.8778ZM174.702 29.3125H167.049V50.25H170.24V42.3168H174.702C178.246 42.3168 181.722 39.8064 181.722 35.8136C181.722 31.8229 178.237 29.3125 174.702 29.3125ZM174.785 39.4044H170.24V32.2249H174.785C177.168 32.2249 178.528 34.1617 178.528 35.8136C178.528 37.4342 177.168 39.4044 174.785 39.4044ZM194.512 36.3957C192.206 36.3957 189.809 37.3923 188.823 39.6012L191.655 40.7632C192.264 39.6012 193.385 39.2243 194.57 39.2243C196.225 39.2243 197.904 40.1979 197.93 41.9169V42.1367C197.353 41.8101 196.116 41.3265 194.596 41.3265C191.546 41.3265 188.438 42.9701 188.438 46.0374C188.438 48.843 190.936 50.6499 193.744 50.6499C195.892 50.6499 197.077 49.7015 197.821 48.5981H197.93V50.2165H201.012V42.1849C201.012 38.4727 198.18 36.3957 194.512 36.3957ZM194.127 47.8694C193.083 47.8694 191.629 47.3627 191.629 46.096C191.629 44.4755 193.443 43.8536 195.013 43.8536C196.418 43.8536 197.077 44.1572 197.93 44.5571C197.68 46.4959 195.975 47.8694 194.127 47.8694ZM212.241 36.8542L208.573 45.9306H208.464L204.672 36.8542H201.23L206.928 49.5381L203.677 56.5962H207.012L215.792 36.8542H212.241ZM183.475 50.25H186.675V29.3125H183.475V50.25Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_63_1707",
    x1: 37.8017,
    y1: 52.4113,
    x2: 9.69759,
    y2: 23.7013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_63_1707",
    x1: 58.3944,
    y1: 33.4976,
    x2: 16.9908,
    y2: 33.4976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_63_1707",
    x1: 42.9818,
    y1: 29.654,
    x2: 4.87028,
    y2: -9.27908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_63_1707",
    x1: 12.9865,
    y1: 66.7049,
    x2: 30.005,
    y2: 49.3196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStore);
export default __webpack_public_path__ + "static/media/play-store.c2c03d1a08f137c6f1d450f3b0a3e007.svg";
export { ForwardRef as ReactComponent };